import type { OrderStatusDisplayProps } from './OrderStatusDisplay.types'
import { IconCircleCheckFilled } from '@tabler/icons-react'
import { getEtaDisplayText, isOrderOnTheWay } from '@/entities/order/lib/order.eta'
import { OrderStatusDisplayBase } from './OrderStatusDisplayBase'

export function OrderStatusDisplay({
  orderStatus,
  eta,
  etaDirection,
  scheduledTimeForCollection,
  displayState,
  ...rest
}: OrderStatusDisplayProps) {
  let indicator: React.ReactNode
  if (orderStatus === 'Completed' || orderStatus === 'Fulfilled') {
    indicator = <IconCircleCheckFilled size={10.8} color="inherit" data-testid="custom-indicator" />
  }

  let statusColor: string | undefined
  if (/cancelled/i.test(orderStatus) && displayState?.color) {
    statusColor = displayState.color
  }

  const statusText = getEtaDisplayText({
    eta,
    etaDirection,
    scheduledTimeForCollection,
    orderStatus,
    isOnTheWay: isOrderOnTheWay(orderStatus),
    displayState,
  })

  return (
    <OrderStatusDisplayBase
      statusText={statusText}
      statusColor={statusColor}
      displayState={displayState}
      indicator={indicator}
      {...rest}
    />
  )
}
